// Module Name
export const USE_NAME = `EventMessage`;

// Actions
export const USE_FETCH = `[${USE_NAME}] Fetch`;
export const USE_FETCH_OPTION = `[${USE_NAME}] Fetch option`;
export const USE_FIND = `[${USE_NAME}] Find`;

// Mutations
export const USE_META = `[${USE_NAME}] meta`;
export const USE_OBTAIN = `[${USE_NAME}] obtain`;
export const USE_CLEAR = `[${USE_NAME}] clear`;
export const USE_SET_LOADING = `[${USE_NAME}] set loading`;
export const USE_ERROR = `[${USE_NAME}] error`;
export const USE_OBTAIN_DETAIL = `[${USE_NAME}] obtain detail`;
export const USE_OBTAIN_OPTION = `[${USE_NAME}] obtain options`;

export default {};
